import { useEffect, useState } from 'react';
import { api, type NotificationItem } from '../api';

export function NotificationsBell() {
  const [items, setItems] = useState<NotificationItem[]>([]);
  const [open, setOpen] = useState(false);

  async function load() {
    setItems(await api.get<NotificationItem[]>('/api/notifications').catch(() => []));
  }

  useEffect(() => {
    void load();
  }, []);

  const unread = items.filter((n) => !n.readAt).length;

  async function markAll() {
    await api.post('/api/notifications/read-all');
    await load();
  }

  return (
    <div className="bell">
      <button className="btn" onClick={() => setOpen((o) => !o)}>
        🔔{unread > 0 ? ` ${unread}` : ''}
      </button>
      {open && (
        <div className="dropdown">
          <div className="row" style={{ justifyContent: 'space-between' }}>
            <strong>Notifications</strong>
            <button className="btn" onClick={() => void markAll()} disabled={unread === 0}>Mark all read</button>
          </div>
          {items.length === 0 && <p className="empty">Nothing here.</p>}
          {items.map((n) => (
            <div key={n.id} className={n.readAt ? 'notif' : 'notif unread'}>
              <div>{n.title}</div>
              {n.body && <div className="muted">{n.body}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
